import React from 'react';
import { useTranslation } from 'react-i18next';
import LocalizedLink from 'components/common/LocalizedLink';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import styles from './providerTicker.module.scss';
import { ProviderIcon } from 'components/icons';
import * as Logos from '../providerCarousel/providerLogos';
import ProviderLogo from 'components/common/providerLogo/ProviderLogo';

import { useGetSubProvidersQuery } from 'store/gamesApi';

export const PROVIDER_LOGOS: Record<string, React.FC<any>> = {
  bgmng: Logos.BGamingLogo,
  bgaming: Logos.BGamingLogo,
  evolution: Logos.EvolutionLogo,
  evolutiongaming: Logos.EvolutionLogo,
  pragmaticexternal: Logos.PragmaticPlayLogo,
  pragmatic: Logos.PragmaticPlayLogo,
  pragmaticplay: Logos.PragmaticPlayLogo,
  hacksaw: Logos.HacksawLogo,
  hacksawgaming: Logos.HacksawLogo,
  relax: Logos.RelaxLogo,
  relaxgaming: Logos.RelaxLogo,
  nolimit: Logos.NolimitCityLogo,
  nolimitcity: Logos.NolimitCityLogo,
  playngo: Logos.PlaynGoLogo,
  novomatic: Logos.NovomaticLogo,
  endorfina: Logos.EndorfinaLogo,
};

const ProviderTicker: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useLocalizedNavigate();
  const { data: response } = useGetSubProvidersQuery({ page: 1, limit: 42 });

  const providers = React.useMemo(() => {
    return response?.data?.docs || [];
  }, [response]);

  if (!providers.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>
          <ProviderIcon width="24" height="24" style={{ color: 'var(--text-active)' }} />
          {t('common.providers', 'Providers')}
        </div>
        <button
          className={styles.seeAllBtn}
          aria-label={t('common.seeAllProviders', 'See all providers')}
          onClick={() => navigate('/casino/providers')}
        >
          {t('common.seeAll', 'See All')}
        </button>
      </div>
      <div className={styles.tickerContainer}>
        <div
          className={styles.tickerList}
          style={{
            animationDuration: `${providers.length * 2}s`,
            animation: providers.length <= 8 ? 'none' : undefined,
            justifyContent: providers.length <= 8 ? 'center' : 'flex-start',
          }}
        >
          {/* Render multiple sets to ensure it covers wide screens and loops seamlessly */}
          {providers.map((provider: any, index: number) => {
            const slug = provider.name;

            return (
              <LocalizedLink
                key={`${provider.id}-${index}`}
                to={`/casino/providers/${slug}`}
                className={styles.providerItem}
              >
                <ProviderLogo
                  name={provider.name}
                  displayName={provider.displayName}
                  imageUrl={provider.imageUrl}
                  className={styles.logoSvg}
                  textClassName={styles.fallbackText}
                />
              </LocalizedLink>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProviderTicker;
